import { ProcessValidationIssue } from './processValidation';

export type ValidationActionType =
  | 'segment.delete'
  | 'segment.reorder'
  | 'node.remove'
  | 'session.persist';

export interface ValidationPolicyDecision {
  canMutate: boolean;
  warning?: string;
  blockingMessage?: string;
}

const EDIT_ACTIONS: ValidationActionType[] = ['segment.delete', 'segment.reorder', 'node.remove'];

/**
 * Política de validación:
 * - Edición: permisiva (deja mutar, pero emite warning si hay issues).
 * - Persistencia final: estricta (bloquea si hay issues).
 */
export function canMutateWithIssues(
  actionType: ValidationActionType,
  issues: ProcessValidationIssue[],
  context?: { processName?: string },
): ValidationPolicyDecision {
  const hasIssues = issues.length > 0;

  if (!hasIssues) return { canMutate: true };

  if (EDIT_ACTIONS.includes(actionType)) {
    const processName = context?.processName ? ` "${context.processName}"` : '';
    return {
      canMutate: true,
      warning: `Se aplicó el cambio de edición, pero el proceso${processName} quedó con inconsistencias estructurales.`,
    };
  }

  if (actionType === 'session.persist') {
    const sample = issues[0]?.message;
    return {
      canMutate: false,
      blockingMessage: sample
        ? `No se pudo guardar: hay inconsistencias estructurales. Primer error: ${sample}`
        : 'No se pudo guardar: hay inconsistencias estructurales en el proceso.',
    };
  }

  return {
    canMutate: false,
    blockingMessage: 'No se pudo completar la acción por inconsistencias estructurales.',
  };
}
